import React from 'react';
import loading from '../../static/loading.svg'

export default function LoadingSmall({width}) {

    const containerStyle = {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    }

    const style = {
        position: 'relative',
        textAlign: 'center',
    }

    return (
        <div style={containerStyle}>
            <div style={style}>
                <img src={loading} alt="loading" width={width || "25px"}/>
            </div>
        </div>
    );
}
